import { useEffect, useState } from 'react';
import { getSolutions } from '../services/solution';

export const SolutionsCatalog = () => {
  const [solutions, setSolutions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSolutions = async () => {
      try {
        const data = await getSolutions();
        setSolutions(data);
      } catch (error) {
        console.error("Failed to fetch solutions:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSolutions();
  }, []);

  if (loading) {
    return <div className="p-8 flex justify-center"><div className="animate-pulse">Loading Solutions...</div></div>;
  }

  return (
    <div className="p-8 max-w-7xl mx-auto">
      <div className="flex justify-between items-center mb-8">
        <div>
          <h1 className="text-3xl font-bold text-gray-900">Solution Catalog</h1>
          <p className="text-gray-500 mt-2">Manage predefined service packages used for AI recommendations.</p>
        </div>
        <button className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg">
          + Add Solution
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {solutions.map((service, idx) => (
          <div key={idx} className="bg-white rounded-xl shadow-sm border p-6 flex flex-col h-full">
            <div className="flex justify-between items-start mb-4">
              <h3 className="text-lg font-bold text-gray-900 leading-tight">{service.name}</h3>
              <span className={`w-3 h-3 rounded-full ${service.active ? 'bg-green-500' : 'bg-gray-300'}`} title={service.active ? 'Active' : 'Inactive'}></span>
            </div>

            <p className="text-gray-600 text-sm mb-4 flex-grow">{service.description}</p>

            <div className="bg-gray-50 p-3 rounded-lg space-y-2 text-sm text-gray-700 mb-4">
              <div className="flex justify-between"><span className="font-semibold text-gray-500">Duration:</span> <span>{service.estimated_duration}</span></div>
              <div className="flex justify-between"><span className="font-semibold text-gray-500">Price:</span> <span>{service.estimated_price_range}</span></div>
            </div>

            <div className="flex flex-wrap gap-2">
              <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-xs font-medium">{service.category}</span>
              <span className="px-2 py-1 bg-purple-100 text-purple-700 rounded text-xs font-medium">{service.complexity}</span>
            </div>
          </div>
        ))}
        {solutions.length === 0 && (
          <div className="col-span-full py-12 text-center text-gray-500 border-2 border-dashed rounded-xl">
            No solutions found in the catalog.
          </div>
        )}
      </div>
    </div>
  );
};

export default SolutionsCatalog;
